import { render } from "./EditMailList.vue?vue&type=template&id=57d645fb&scoped=true"
import script from "./EditMailList.vue?vue&type=script&lang=js"
export * from "./EditMailList.vue?vue&type=script&lang=js"

import "./EditMailList.vue?vue&type=style&index=0&id=57d645fb&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57d645fb"]])

export default __exports__